module.exports = __webpack_public_path__ + "static/media/skype.37d1a7af.png";